var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.03 114.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentcolor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-223.52,281.17A29.2,29.2,0,0,1-253,252.23a29.14,29.14,0,0,1,29.41-29.47,29.28,29.28,0,0,1,29.27,29.18A29.29,29.29,0,0,1-223.52,281.17Z",
    transform: "translate(278.82 -222.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-216.56,332c-18.32,0-35.77.09-53.22-.07-4.26,0-7.18-2.64-8.17-6.82-2.79-11.67,1.15-21.46,11.32-28.15,11.34-7.45,24.17-10,37.44-10.85,4.08-.26,8.19,0,13.14,0C-227.63,301.34-228,316.22-216.56,332Z",
    transform: "translate(278.82 -222.76)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-191.44,337.22a28,28,0,0,1-28.27-27.66,28.28,28.28,0,0,1,27.8-28.27,28,28,0,0,1,28.12,27.8A27.66,27.66,0,0,1-191.44,337.22ZM-187.8,316h0c0-2.31.41-4.74-.15-6.91-.37-1.42-2.26-3.56-3.27-3.45-1.53.16-4,1.87-4.13,3.13a69.33,69.33,0,0,0,0,14.33c.13,1.28,2.7,3.27,4,3.18s2.94-2.29,3.42-3.87C-187.35,320.47-187.8,318.18-187.8,316Zm-2.49-24.71-2.26-.11c-1.47,2-3.79,3.85-4.2,6.06a4.29,4.29,0,0,0,5.05,5.12c2-.34,4.82-2.95,5-4.75C-186.55,295.66-189,293.44-190.29,291.32Z",
    transform: "translate(278.82 -222.76)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon-white.9932c5362ce9d30c683688aa717ed407.svg";
export { ForwardRef as ReactComponent };